import { render, staticRenderFns } from "./ampliar.vue?vue&type=template&id=686a3d32&"
import script from "./ampliar.vue?vue&type=script&lang=js&"
export * from "./ampliar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('686a3d32')) {
      api.createRecord('686a3d32', component.options)
    } else {
      api.reload('686a3d32', component.options)
    }
    module.hot.accept("./ampliar.vue?vue&type=template&id=686a3d32&", function () {
      api.rerender('686a3d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/ampliar.vue"
export default component.exports